import { CompanyDto } from './company-dto.model';


export class LocationDto implements ILocationDto {
    id!: number;
    company!: CompanyDto;
    locationName!: string | undefined;
    isActive!: boolean;
    longitude!: number | undefined;
    latitude!: number | undefined;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.company = _data["company"] ? CompanyDto.fromJS(_data["company"]) : <any>undefined;
            this.locationName = _data["locationName"];
            this.isActive = _data["isActive"];
            this.longitude = _data["longitude"];
            this.latitude = _data["latitude"];
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["company"] = this.company ? this.company.toJSON() : <any>undefined;
        data["locationName"] = this.locationName;
        data["isActive"] = this.isActive;
        data["longitude"] = this.longitude;
        data["latitude"] = this.latitude;
        return data; 
    }
}

export interface ILocationDto {
    id: number;
    company: CompanyDto;
    locationName: string | undefined;
    isActive: boolean;
    longitude: number | undefined;
    latitude: number | undefined;
}

